<!--典型案例-->

<template>
    <div class='all-body'>
        <div class='child-body'>
            <div class='scenarioTitle'>{{name}}</div>
            <div>
                <ul class='classicCase'>
                    <li v-for="(item,index) of data">
                        <img :src="item.img" alt="">
                        <span class='classicCase-title'>{{item.title}}</span>
                        <div class='classicCase-label'>
                            <span v-for='items of item.industry.split(",")'>{{items}}</span>
                           
                        </div>
                        <div class='classicCase-content'>
                            {{item.html}}
                        </div>
                        <div class="lawAI">
                            <span class='lawAI-title lawAI-common'>使用法律AI</span>
                            <span class="lawAI-content lawAI-common">{{item.AI}}</span>
                        </div>
                    </li> 
                </ul>
                <span class="moreCases">更多案例</span>
                
            </div>

            
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data','name']
}
</script>
<style scoped>
.classicCase{
    display: flex;
    justify-content: space-between;
}
.classicCase li{
    width: 26.8%;
    border: 1px solid #E3E3E3;
    padding: 35px 35px 35px 30px;
}
.classicCase li img{
    width: 188px;
    height: 75px;
    display: block;
    margin-bottom: 15px;

}
.classicCase-title{
    display: inline-block;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303133;
    line-height: 30px;
    margin-bottom: 15px;
}
.classicCase-label{
    display: flex;
    margin-bottom: 17px;
}
.classicCase-label span{
    padding: 0 10px 0;
    height: 24px;
    line-height: 24px;
    background: #F5F5F5;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303133;
    margin-right: 8px;
}
.classicCase-content{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #606266;
    line-height: 30px;
    margin-bottom: 15px;
}
.lawAI{
    display: flex;
}
.lawAI-common{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
}
.lawAI-content{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1867DD;
    margin-left: 30px;
}
.lawAI-title{
    color: #303133;
}
.moreCases{
    display: block;
    width: 102px;
    height: 32px;
    border: 1px solid #5D5D5D;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303133;
    line-height: 32px;
    text-align: center;
    margin-top: 30px;
    margin: 30px auto 0 ;
    cursor: pointer;
}
</style>